import { useEffect, useState } from "react";
import DiscardSaveButtons from "../../../../components/tv-app/discard-save-buttons";
import {
  IChamomileTeaSubData,
  IMusicTime,
  ISleepCategoryComponentProps,
} from "../../../../utils/types";
import { FormProvider, useForm } from "react-hook-form";
// import Switch from "../../../../components/common/Switch";
import {
  convertTimeToAmPmFormat,
  convertToTimeInputFormat,
} from "../../../../utils/helpers";
import TimeInput from "../../../../components/common/TimeInput";

type IFormData = {
  showCT: boolean;
  data: string | undefined;
  time?: IMusicTime[];
};

const ChamomileTea = ({
  time,
  subData,
  show,
  onSave,
  loading,
}: ISleepCategoryComponentProps<IChamomileTeaSubData[]>) => {
  const [InitialFormData, setInitialFormData] = useState<IFormData>({
    showCT: !!show,
    time: time,
    data: convertToTimeInputFormat(subData[0]?.value),
  });

  const methods = useForm<IFormData>({ defaultValues: InitialFormData });

  const { reset, handleSubmit, setValue, watch } = methods;
  const { data } = watch();

  useEffect(() => {
    setInitialFormData({
      showCT: !!show,
      data: convertToTimeInputFormat(subData[0]?.value),
    });
  }, [subData, show]);

  const onSubmit = (submitData: IFormData) => {
    const value = submitData?.data ?? "";
    onSave({
      show: submitData.showCT,
      subData: [{ ...subData[0], value: convertTimeToAmPmFormat(value) }],
      time: time?.map((item) => ({
        ...item,
        time: convertTimeToAmPmFormat(value),
      })),
    });
  };

  return (
    <FormProvider {...methods}>
      <div className="w-full mt-4">
        <div className="">
          {/* <Switch label="Chamomile Tea  (Hide/Show)" name="showCT" /> */}
        </div>
        <h4 className="text-base leading-[39px] font-normal text-[#1E2F65] whitespace-nowrap">
          Chamomile Tea
        </h4>
        <div className="grid grid-cols-3 gap-2 relative">
          <TimeInput
            name="data"
            rules={{ required: "Start Time is required" }}
            type="time"
            label="Default Selected Time"
            placeholder="03: 00 PM"
            value={data || ""}
            onChange={(e) => setValue("data", e.target.value)}
          />
        </div>

        <DiscardSaveButtons
          onDiscard={() => {
            reset(InitialFormData);
          }}
          onSave={handleSubmit(onSubmit)}
          loading={loading}
          className="mt-10"
        />
      </div>
    </FormProvider>
  );
};

export default ChamomileTea;
